// one answer to "should this move?" for every script driven animation: the system's reduced motion setting
// or the person's own calm switch in Setup > Look

export function reducedMotion(): boolean {
  if (typeof document !== "undefined" && document.documentElement.classList.contains("calm")) return true;
  return typeof matchMedia === "function" && matchMedia("(prefers-reduced-motion: reduce)").matches;
}

// for scrollIntoView and scrollTo: smooth only when motion is welcome
export function scrollBehavior(): ScrollBehavior {
  return reducedMotion() ? "auto" : "smooth";
}
